var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRapidOnset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3982 13.0827C25.8054 13.2595 26.0474 13.6835 25.9923 14.124L25.1328 21H33C33.388 21 33.741 21.2245 33.9056 21.5758C34.0702 21.9272 34.0166 22.3421 33.7682 22.6402L23.7682 34.6402C23.484 34.9812 23.009 35.0941 22.6018 34.9173C22.1946 34.7405 21.9527 34.3165 22.0077 33.876L22.8672 27H15C14.612 27 14.259 26.7755 14.0944 26.4242C13.9298 26.0728 13.9834 25.6579 14.2318 25.3598L24.2318 13.3598C24.516 13.0188 24.991 12.9059 25.3982 13.0827ZM17.1351 25H24C24.2868 25 24.5599 25.1232 24.7497 25.3382C24.9395 25.5532 25.0279 25.8394 24.9923 26.124L24.4154 30.7395L30.865 23H24C23.7132 23 23.4402 22.8768 23.2503 22.6618C23.0605 22.4468 22.9722 22.1606 23.0077 21.876L23.5847 17.2605L17.1351 25Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidOnset);
export default __webpack_public_path__ + "static/media/rapid-onset.1549bc28aa49b74804bd5b02cb85b083.svg";
export { ForwardRef as ReactComponent };